import { Button, Divider, Stack, Box, Typography, Alert } from '@mui/material';
import FormInput from '../form/form-input';
import React, { useContext, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import GoogleOAuthChoice from './Google/GoogleOAuthChoice';
import FacebookOAuthChoice from './Facebook/FacebookOAuthChoice';
import MicrosoftOAuthChoice from './Microsoft/MicrosoftOAuthChoice';
import auth from '../utils/auth';
import useForm from '../hooks/useForm';
import { ConfigContext } from '../Config/ConfigContext';
import http from '../utils/http';
import VerificationEmail from './VerificationEmail';
import UserInit from './UserInit';
import Spinner from '../../globalComponents/spinner';
import SpinnerSize from '../../enums/spinnerSize';

Auth.propTypes = {
	LoginHeaderLogo: PropTypes.string,
	LoginFooterLogo: PropTypes.string,
	LoginLeftLogo: PropTypes.string,
	LoginRightLogo: PropTypes.string,
	signInBlurb: PropTypes.string,
	signInBackgroundColor: PropTypes.string,
	children: PropTypes.element.isRequired,
	aboveElements: PropTypes.element,
	belowElements: PropTypes.element,
};

/*
 * This should be the landing page for Auth with all of the
 * customized buttons where users choose to render the
 * Google, Facebook, or Twitter provider with the app children
 * */
export default function Auth(props) {
	//const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated())

	//const [useGoogleOAuth, setUseGoogleOAuth] = useState(false);
	//eslint-disable-next-line
	const [useFacebookOAuth, setUseFacebookOAuth] = useState(false);
	const [useShadowAuth, setUseShadowAuth] = useState(false);
	const [userInit, setUserInit] = useState(false);
	//const [useMicrosoftAuth, setUseMicroosftAuth] = useState(false);
	//const [choiceChosen, setChoiceChosen] = useState(false);
	const { config } = useContext(ConfigContext);
	const [authSuccess, setAuthSuccess] = useState(auth.isAuthenticated());

	useEffect(() => {
		if (!authSuccess && config.authType == 'cognito') {
			window.location.href = config.loginUrl;
		}
	}, [config, authSuccess]);

	useEffect(() => {
		const queryParams = window.location.search
			.replace('?', '')
			.split('&')
			.reduce((previous, current) => {
				const [key, value] = current.split('=');
				return {
					...previous,
					[key]: value,
				};
			}, {});
		if (queryParams.verificationToken) {
			setUserInit(true);
		}
	}, []);

	const googleBtnRef = useRef(null);

	const {
		LoginHeaderLogo,
		LoginFooterLogo,
		LoginLeftLogo,
		LoginRightLogo,
		signInBlurb,
		signInBackgroundColor,
		belowElements,
		aboveElements,
	} = props;

	const { state, onChange, onChangeBulk } = useForm({
		initialState: {
			email: '',
			password: '',
			passwordError: null,
		},
	});

	console.log(config, ' config within auth page');

	return config?.authType ? (
		<React.Fragment>
			{aboveElements}

			{userInit && (
				<Box
					className="auth-container"
					backgroundColor={signInBackgroundColor || '#23102E'}
					sx={{ minWidth: '100%', minHeight: '100%' }}
					display="flex"
					justifyContent={`${!LoginLeftLogo && !LoginRightLogo ? 'start' : 'center'}`}
					alignItems="center"
					flexDirection={`${!LoginLeftLogo && !LoginRightLogo ? 'column' : 'row'}`}
					paddingX="20px"
				>
					{LoginHeaderLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<img
								style={{ maxWidth: '100%', height: '100%' }}
								src={LoginHeaderLogo}
								alt="login header"
							/>
						</Box>
					)}

					{LoginLeftLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<img
								style={{ maxWidth: '100%', height: '100%' }}
								src={LoginLeftLogo}
								alt="login left"
							/>
						</Box>
					)}

					<Box
						padding="20px"
						sx={{
							backgroundColor: 'white',
							width: '100%',
							maxWidth: '335px',
							borderRadius: '20px',
						}}
					>
						<UserInit {...props} />
					</Box>

					{LoginRightLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<img
								style={{ maxWidth: '100%', height: '100%' }}
								src={LoginRightLogo}
								alt="login right"
							/>
						</Box>
					)}

					{LoginFooterLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<Box>
								<img
									style={{ maxWidth: '100%', height: '100%' }}
									src={LoginFooterLogo}
									alt="main circle"
								/>
							</Box>
						</Box>
					)}
				</Box>
			)}
			{!userInit && !authSuccess && !useShadowAuth && (
				<Box
					className="auth-container"
					backgroundColor={signInBackgroundColor || '#23102E'}
					sx={{ width: '100%', height: '100%' }}
					display="flex"
					justifyContent={`${!LoginLeftLogo && !LoginRightLogo ? 'start' : 'center'}`}
					alignItems="center"
					flexDirection={`${!LoginLeftLogo && !LoginRightLogo ? 'column' : 'row'}`}
					paddingX="20px"
				>
					{LoginHeaderLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<img
								style={{ maxWidth: '100%', height: '100%' }}
								src={LoginHeaderLogo}
								alt="login header"
							/>
						</Box>
					)}

					{LoginLeftLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<img
								style={{ maxWidth: '100%', height: '100%' }}
								src={LoginLeftLogo}
								alt="login left"
							/>
						</Box>
					)}

					<Box
						padding="20px"
						sx={{
							backgroundColor: 'white',
							width: '100%',
							maxWidth: '335px',
							borderRadius: '20px',
						}}
					>
						<Stack
							direction="column"
							alignItems="center"
							justifyContent="center"
							gap="4px"
						>
							<Typography
								sx={{ fontSize: '24px', fontWeight: 800, lineHeight: '28.8px' }}
							>
								Sign in
							</Typography>
							{signInBlurb && (
								<Typography
									sx={{
										color: '#5B626E',
										fontSize: '14px',
										lineHeight: '21px',
										fontWeight: 700,
										width: '60%',
										textAlign: 'center',
									}}
								>
									{signInBlurb}
								</Typography>
							)}
						</Stack>
						<Stack
							gap="16px"
							sx={{ marginTop: '20px' }}
							direction="column"
							justifyContent="center"
						>
							{config.googleOAuth.enabled && (
								<React.Fragment>
									<GoogleOAuthChoice
										parentBtnRef={googleBtnRef}
										setAuthSuccess={setAuthSuccess}
										{...props}
									/>
									<Button
										ref={googleBtnRef}
										sx={{
											//borderRadius: '90px',
											//border: '1px solid #5b626E',
											color: '#1B1C1E',
											textTransform: 'initial',
											padding: '8px',
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											fontWeight: '700',
											fontSize: '15px',
										}}
										onClick={() => {
											//setUseGoogleOAuth(true);
											setUseFacebookOAuth(false);
											//setChoiceChosen(true);
										}}
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g clipPath="url(#clip0_560_4093)">
												<path
													d="M23.766 12.2763C23.766 11.4605 23.6999 10.6404 23.5588 9.83789H12.24V14.4589H18.7217C18.4528 15.9492 17.5885 17.2676 16.323 18.1054V21.1037H20.19C22.4608 19.0137 23.766 15.9272 23.766 12.2763Z"
													fill="#4285F4"
												/>
												<path
													d="M12.2401 24.0008C15.4766 24.0008 18.2059 22.9382 20.1945 21.1039L16.3276 18.1055C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3912C3.55371 21.4434 7.7029 24.0008 12.2401 24.0008Z"
													fill="#34A853"
												/>
												<path
													d="M5.50253 14.3002C4.99987 12.8099 4.99987 11.196 5.50253 9.70569V6.61475H1.51649C-0.18551 10.0055 -0.18551 14.0004 1.51649 17.3912L5.50253 14.3002Z"
													fill="#FBBC04"
												/>
												<path
													d="M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z"
													fill="#EA4335"
												/>
											</g>
											<defs>
												<clipPath id="clip0_560_4093">
													<rect width="24" height="24" fill="white" />
												</clipPath>
											</defs>
										</svg>
										Continue with Google
									</Button>
								</React.Fragment>
							)}
							{config.facebookOAuth.enabled && (
								<React.Fragment>
									<FacebookOAuthChoice
										setAuthSuccess={setAuthSuccess}
										{...props}
									/>
								</React.Fragment>
							)}
							{config.microsoftOAuth.enabled && (
								<React.Fragment>
									<MicrosoftOAuthChoice
										setAuthSuccess={setAuthSuccess}
										{...props}
									/>
								</React.Fragment>
							)}
						</Stack>
						{config.emailAuth.enabled && (
							<React.Fragment>
								<Stack sx={{ margin: '16px 0px 0px' }} gap="16px">
									<Divider />
								</Stack>
								<Stack gap="16px">
									<FormInput
										label="Email"
										path="email"
										value={state.values.email}
										error={state.errors.email}
										onChange={onChange}
									/>
									<Button
										sx={{
											borderRadius: '90px',
											border: '1px solid #5b626E',
											color: '#1B1C1E',
											textTransform: 'initial',
											padding: '8px',
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											fontWeight: '700',
											fontSize: '15px',
										}}
										onClick={async () => {
											await http.get(
												{},
												`${config.uri.base}/user/init?signInPlatform=shadow&email=${state.values.email}`
											);
											setUseShadowAuth(true);
										}}
									>
										Continue
									</Button>
								</Stack>
							</React.Fragment>
						)}

						{config.passwordAuth.enabled && (
							<React.Fragment>
								<Stack sx={{ margin: '16px 0px 0px' }} gap="16px">
									<Divider />
								</Stack>
								<Stack>
									<FormInput
										label="Email"
										path="email"
										value={state.values.email}
										error={state.errors.email}
										onChange={onChange}
										type="email"
									/>
									<FormInput
										label="Password"
										path="password"
										value={state.values.password}
										error={state.errors.password}
										onChange={onChange}
										type="password"
									/>
									<Button
										sx={{
											borderRadius: '90px',
											border: '1px solid #5b626E',
											color: '#1B1C1E',
											textTransform: 'initial',
											padding: '8px',
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											fontWeight: '700',
											fontSize: '15px',
											marginTop: '16px',
										}}
										onClick={async () => {
											let result = await http.get(
												{},
												`${config.uri.base}/login?email=${state.values.email}&password=${state.values.password}`
											);

											if (result.errored == true) {
												onChangeBulk({
													passwordError: result.error,
													password: '',
													email: '',
												});

												return;
											}

											auth.setBearerToken(result);
											setAuthSuccess(true);
										}}
									>
										Continue
									</Button>

									{state.values.passwordError?.length > 0 && (
										<Alert sx={{ marginTop: '16px' }} severity="warning">
											{state.values.passwordError}
										</Alert>
									)}

									<Button
										sx={{
											borderRadius: '90px',
											border: '1px solid #5b626E',
											color: '#1B1C1E',
											textTransform: 'initial',
											padding: '8px',
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											fontWeight: '700',
											fontSize: '15px',
											marginTop: '16px',
										}}
										onClick={() => {
											location.href = `${config.uri.webapp}/register`;
										}}
									>
										Create Account
									</Button>

									<Button
										sx={{
											borderRadius: '90px',
											border: '1px solid #5b626E',
											color: '#1B1C1E',
											textTransform: 'initial',
											padding: '8px',
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											fontWeight: '700',
											fontSize: '15px',
											marginTop: '16px',
										}}
										onClick={() => {
											location.href = `${config.uri.webapp}/forgot-password`;
										}}
									>
										Forgot Password
									</Button>
								</Stack>
							</React.Fragment>
						)}
					</Box>

					{LoginRightLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<img
								style={{ maxWidth: '100%', height: '100%' }}
								src={LoginRightLogo}
								alt="login right"
							/>
						</Box>
					)}

					{LoginFooterLogo && (
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}
						>
							<Box>
								<img
									style={{ maxWidth: '100%', height: '100%' }}
									src={LoginFooterLogo}
									alt="main circle"
								/>
							</Box>
						</Box>
					)}
				</Box>
			)}
			{useShadowAuth && <VerificationEmail {...props} />}
			{authSuccess && props.children}

			{belowElements}
		</React.Fragment>
	) : (
		<div className="w-[100vw] h-[100vh] flex justify-center items-center">
			<Spinner size={SpinnerSize.LARGE} />
		</div>
	);
}
